<!-- 个人银行卡四要素认证 -->
<template>
  <div class="manual-root-sty">
    <el-form 
      ref="manualFormRef"
      size="small"
      :model="manualForm"
      :rules="manualRules"
      label-width="170px"
      label-suffix=" ："
      class="form-sty"
      @submit.native.prevent="handleSubmit"
    >
      <el-form-item label="姓名" prop="name">
        <el-input v-model.trim="manualForm.name" :disabled="manualDis.nameDis" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="证件类型" prop="cardType">
        <el-select v-model="manualForm.cardType" placeholder="请选择证件类型" style="width: 100%;">
          <el-option
            v-for="item in cardTypeList"
            :key="item.key"
            :label="item.label"
            :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号码" prop="card">
        <el-input v-model.trim="displayIdCard" :disabled="manualDis.idCardDis" placeholder="请输入证件号码"></el-input>
      </el-form-item>
      <el-form-item prop="certPhoto">
        <template slot="label">
          <span>
            证件照片：
            <br />
            <span style="color: #ec1c1c;">（身份信息页）</span>
          </span>
        </template>
        <div class="card-box">
          <div class="bank">
            <el-upload
              action="#"
              :show-file-list="false"
              :before-upload="file => beforeIdeCareUpload(file,1)"
            >
              <img v-if="manualForm.certPhoto" class="card-img" :src="manualForm.certPhotoUrl" />
              <div v-else>
                <div class="card-item">
                  <i
                    class="el-icon-plus avatar-uploader-icon"
                    style="font-size:3vw;color:#C2C2C2"
                  ></i>
                </div>
              </div>
            </el-upload>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-alert
          title="建议上传：《台湾居民来往大陆通行证》《港澳居民来往内地通行证》《护照》"
          type="warning"
          :closable="false">
        </el-alert>
      </el-form-item>
      <el-form-item label="手持证件照片" prop="handheldCertPhoto">
        <div class="card-box">
          <div class="bank">
            <el-upload
              action="#"
              :show-file-list="false"
              :before-upload="file => beforeIdeCareUpload(file,2)"
            >
              <img v-if="manualForm.handheldCertPhoto" class="card-img" :src="manualForm.handheldCertPhotoUrl" />
              <div v-else>
                <div class="card-item">
                  <i
                    class="el-icon-plus avatar-uploader-icon"
                    style="font-size:3vw;color:#C2C2C2"
                  ></i>
                </div>
              </div>
            </el-upload>
            <img
              class="card-img"
              src="/images/auth/authIcon/cardOnHand.png"
              alt="示例图"
            />
          </div>
        </div>
      </el-form-item>
      <!-- <el-form-item label="" prop="authorizationLetter">
        <p class="tips-sty">
          请完善信息后
          <span class="down-txt-sty" @click="downloadFileFn">下载《数字证书申请表》</span>，签字后拍照上传
        </p>
        <el-upload
          ref="uploadCare"
          style="width: 200px"
          action="#"
          accept=".jpg,.png,.jpeg"
          :show-file-list="false"
          :before-upload="(file) => beforeIdeCareUpload(file,3)"
        >
          <img v-if="manualForm.authorizationLetter" :src="manualForm.authorizationLetterUrl" width="100" />
          <div v-else class="upload-sty">
            <i class="el-icon-plus upload-text-sty"></i>
            <p class="upload-text-sty">点击上传</p>
            <p class="upload-text-tips">支持jpg、png格式图片</p>
          </div>
        </el-upload>
      </el-form-item> -->
      <!-- 协议弹窗 -->
      <ProtocolRead :Agree.sync="agreement" class="btns-sty"></ProtocolRead>
      <el-form-item>
        <el-button type="primary" native-type="submit" class="sub-btn-sty">提交审核</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>
<script>
// components
import ProtocolRead from "@/components/protocol/indexNew.vue"
// API
import { ApiMethods,postFileTempUpload } from "@/assets/js/http-serve/http-methods";
import ApplyTableController from "@/assets/js/http-serve/applyTableController";
// tool
import { BUSITYPE } from "@/assets/js/utils/others";
import mixinsLoading from '@/mixins/loading'
import mixinsAlertPopup from '@/mixins/alterPopup'
import { desensitizeIdCard } from '@/assets/js/utils/publicMethods'
import {noChinese} from "@/assets/js/lib/valid-methods"

export default {
  props:{
    parameters:{
      type:Object,
      default: () => ({
        APIAUTHINFO: {},
        AuthUser: {}
      })
    },
  },
  components: { ProtocolRead },
  mixins:[mixinsLoading,mixinsAlertPopup],
  data () {
    // 这里存放数据
    return {
      BUSITYPE,
      // 协议
      agreement:false,
      // 表单
      manualForm:{
        name:'',
        card:'',
        cardType:'4',
        /** 证件照 */
        certPhotoUrl:'',
        certPhoto:'',
        /** 手持证件照 */
        handheldCertPhotoUrl:'',
        handheldCertPhoto:'',
        /** 数字证书申请表 */
        authorizationLetter:'',
        authorizationLetterUrl:'',
      },
      manualRules:{
        name:[{ required: true, message: "请输入姓名", trigger: "blur" }],
        card:[
          { required: true, message: "请输入证件号码", trigger: "blur" },
          { validator: noChinese, trigger: ["change", "blur"]}
        ],
        cardType:[{required:true,message:'请选择证件类型',trigger:'blur'}],
        certPhoto:[{required:true,message:'请上传证件照',trigger:'blur'}],
        handheldCertPhoto:[{required:true,message:'请上传手持证件照',trigger:'blur'}],
        authorizationLetter:[{required:true,message:'请上传《数字证书申请表》',trigger:'blur'}],
      },
      manualDis:{
        nameDis:false,
        idCardDis:false,
      },
      cardTypeList:[
      // 护照：2;台胞证：3;港澳居民来往内地通行证：4
        {key:'4',label:'港澳居民来往内地通行证'}, 
        {key:'3',label:'台湾居民来往大陆通行证'}, 
        {key:'2',label:'护照'}, 
      ]
    }
  },
  // 监听属性 类似于data概念
  computed: {
    // 展示用的计算属性：禁用时脱敏，启用时正常
    displayIdCard: {
      get() {
        const {fieldAttributes:FB} = this.parameters.APIAUTHINFO;
        const Privacy = FB && FB.identityCard && FB.identityCard.isPrivacy;
        if (this.manualForm.card && this.manualDis.idCardDis && Privacy) {
          return desensitizeIdCard(this.manualForm.card,'idCard')
        }
        return this.manualForm.card
      },
      set(val) {
        // 如果不禁用，用户输入时同步到真实数据
        if (!this.manualDis.idCardDis) {
          this.manualForm.card = val
        }
      }
    }
  },
  // 方法集合
  methods:{
    /** 提交表单 */
    handleSubmit(){
      this.$refs.manualFormRef.validate( async (valid)=>{
        if(valid){
          if (!this.agreement) {
            return this.mixins_alertPopup({msg:"请先阅读并同意《数字证书服务协议》",type:'warning'});
          }
          await this.$emit('updateRecode');
          // 查询是否存在签署链接（以及结果）
          await this.statusHand();
        }
      })
    },
    /** 查询授权书签署状态 0未签，1已签 */
    statusHand(){
      this.mixins_loadingStart('正在查询授权书签署状态...');
      ApiMethods.stateless.nonChineseApplyTableStatus({
        ...this.manualForm,
        ...this.$route.query
      }).then(res=>{
        if(!res.success) {
          this.mixins_loadingClose()
          return
        }
        res.success && res.data === 1 ? this.applyHand() : this.signLinkHand();
      });
    },
    /** 获取实名协议签约链接 */
    signLinkHand(){
      this.mixins_loadingStart("正在获取签约链接，请稍等...");
      // 将表单暂存起来
      sessionStorage.setItem('session_manualForm',JSON.stringify(this.manualForm))
      const {name,card,cardType} = this.manualForm;
      ApiMethods.stateless.nonChineseApplyTable({name,card,cardType,backUrl:window.location.href,...this.$route.query})
      .then(res => {
        if(!res.success) {
          this.mixins_alertPopup({msg:res.description,type:'error'});
          return 
        }
        if(res.data){
          window.location.href=res.data;
        }
      }).finally(()=>{
        setTimeout(() => {
          this.mixins_loadingClose()
        }, 2000);
      })
    },
    /** 提交授权书 */
    applyHand(){
      this.mixins_loadingStart("正在发起审核，请稍等......");
      ApiMethods.stateless.manualAppro({...this.manualForm,...this.$route.query})
      .then(res => {
        if(!res.success) {
          switch (res.code) {
            case '19003':
              this.mixins_alertPopup({msg:'当前认证方式今日验证次数超限，请切换认证方式或明日再试！',type:'error'});
              break;
            case '19004':
              const {failBackUrl:url} = this.parameters.APIAUTHINFO;
              if(url){
                location.href = url;
              }else{
                this.mixins_alertPopup({msg:'认证次数超限，请明日重试！',type:'error'});
              }
              break;
            default:
              this.mixins_alertPopup({msg:res.description,type:'error'});
              break;
          }
          return ;
        }
        sessionStorage.removeItem('session_manualForm');
        this.$emit('turnPage',1);
      })
      .finally(() => {this.mixins_loadingClose()});
    },
    /** 文件上传事件 
     * @param {number} type 1 证件照 2 手持证件照 3 申请书
    */
    beforeIdeCareUpload(file, type) {
      const re = new RegExp("(.jpg|.png|.jpeg)$", "i"),
        _sz = type === 3 ? 5 : 20;
      const FileSize = file.size / 1024 / 1024 < _sz;
      if (!re.test(file.name)) {
        this.$message.error("文件格式只能是jpg/png/jpeg的文件");
        return false;
      }
      if (!FileSize) {
        this.$message.error(`上传图片大小不能超过 ${_sz}MB!`);
        return false;
      }
      this.mixins_loadingStart("文件上传中~");
      postFileTempUpload({ file, fileType: 1 })
        .then(data => {
          switch (type) {
            case 1:
              this.manualForm.certPhotoUrl = URL.createObjectURL(file);
              this.manualForm.certPhoto = data.tempFile.targetId;
              break;
            case 2:
              this.manualForm.handheldCertPhotoUrl = URL.createObjectURL(file);
              this.manualForm.handheldCertPhoto = data.tempFile.targetId;
              break;
            case 3:
              this.$set(this.manualForm,'authorizationLetterUrl',URL.createObjectURL(file));
              this.manualForm.authorizationLetter = data.tempFile.targetId;
              break;
            default:
              break;
          }
        })
        .catch(err => {
          this.mixins_loadingClose();
          this.mixins_alertPopup({msg:err.description || "上传文件失败",type:'warning'});
        }).finally(()=>{
          this.mixins_loadingClose();
        });
    },
    /** 下载申请表 */
    downloadFileFn () {
      const _this= this,props = ['name','card','cardType'],errMsgs = [];
      _this.$refs.manualFormRef.validateField(props,async (errMsg) => {
        console.log('errMsg:::', errMsg);
        errMsgs.push(errMsg);
        if(errMsgs.length === props.length){
          // 判断是否所有字段都通过验证（errMsg 为空字符串或 undefined）
          const isValid = errMsgs.every(msg => !msg);
          if (!isValid){
            this.$message.error('请先输入姓名和证件号码')
            return;
          }
          _this.mixins_loadingStart('正在下载...');
          setTimeout(() => {
            _this.mixins_loadingClose();
          }, 500);
          const {name,card,cardType} = _this.manualForm;
          await ApplyTableController.manualTableDownRq({
            name,card,cardType,
            ...this.$route.query
          })
        }
      });
    },
  },
  mounted () {
    const sessionManualForm = JSON.parse(sessionStorage.getItem('session_manualForm') || '{}')
    if(Object.keys(sessionManualForm).length > 1){
      // 如果有数据就查询是否已经签约
      this.manualForm ={...sessionManualForm}
      this.statusHand();
    }
  },
  // 监控data中的数据变化
  watch: {
    'parameters.APIAUTHINFO': {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          const {name,identityCard} = newVal;
          if(name){
            this.manualForm.name = name;
            this.manualDis.nameDis = true;
          }
          if(identityCard){
            this.manualForm.card=identityCard;
            this.manualDis.idCardDis=true;
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
}
</script>

<style lang='less' scoped>
  // @import url(); 引入公共css类
  .manual-root-sty{
    padding: 20px;
    .sub-btn-sty{
      width: 75%;
      margin-top: 20px;
    }
    .btns-sty{
      text-align: center;
    }
    .form-sty{
      width: 80%;
      margin: 0 auto;
      .upload-sty {
        width: 245px;
        height: 134px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        border: 1px dashed #ccc;
        .upload-text-tips{
          font-size: 12px;
          color: #606266;
        }
        .upload-text-sty{
          font-size: 1.2vw;
          font-weight: bolder;
          color: #ec1c1c;
        }
      }
      .tips-sty{
        color: #000;
        font-size: 0.9vw;
        margin-bottom: 10px;
        font-weight: bolder;
        .down-txt-sty{
          color: #ec1c1c;
          cursor: pointer;
        }
      }
      .card-box {
        .bank {
          display: flex;
          margin: 10px 0 20px 0;
        }
        .card-size{
          width: 252px;
          height: 162px;
        }
        .card-item {
          .card-size();
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-image: url("/images/auth/authIcon/faceAdd.png");
          background-size: cover;
        }
        .card-img {
          .card-size();
          margin-left: 30px;
        }
      }
      .el-input__icon{
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// pages/auth/APIAuth/person/components/manualReview.vue